import PropTypes from "prop-types"
import { Button } from "@mui/material"
import { AutoAwesome } from "@mui/icons-material"
import { STARTER_PROMPTS } from "../constants"

export default function ChatPromptSuggestions({ onPick }) {
  return <div className="chat-prompt-suggestions">
    <AutoAwesome color="primary" className="prompt-mark" />
    <h2 className="prompt-heading">How can I help?</h2>
    <p className="prompt-subtitle">Ask about your portfolios, performance, or risk. Answers cite Omega Point analytics.</p>
    <div className="prompt-list">
      {STARTER_PROMPTS.map((prompt) =>
        <Button key={prompt} variant="outlined" className="prompt-chip" onClick={() => onPick(prompt)}>
          {prompt}
        </Button>,
      )}
    </div>
  </div>
}

ChatPromptSuggestions.propTypes = {
  onPick: PropTypes.func.isRequired,
}
